import { Component, OnInit } from '@angular/core';
import { Globals } from "../../_models/globals";

@Component({
  selector: 'app-driver-dashboard',
  templateUrl: './driver-dashboard.component.html',
  styleUrls: ['./driver-dashboard.component.css']
})
export class DriverDashboardComponent implements OnInit {

  constructor(private g: Globals) {
    this.g.page = "Dashboard";
  }
  ngOnInit() {
  }

}
